import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './sass/all.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'

const app = createApp(App)
app.use(router)
app.use(store)
app.mount('#app')

// 等 router 導航完成且 mounted 執行後，通知 prerender 截取 HTML
// nextTick 確保所有 mounted hook（含 usePageMeta）都已執行
router.isReady().then(() => {
  setTimeout(() => {
    document.dispatchEvent(new Event('render-event'))
  }, 200)
})

// 啟動時預先載入各頁面 API 資料，避免換頁時內容空白
// fetchExperiences 依賴 skillIdMap，需等 fetchSkillsData 建好 map 後才跑
store.dispatch('fetchAboutProfile')
store.dispatch('fetchCommissionSettings')
store.dispatch('fetchSkillsData').then(() => store.dispatch('fetchExperiences'))
